import * as React from "react";
import {Fragment} from "react";

class Spinner extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {style} = this.props;

		return (
			<Fragment>
				{style !== 'rotate' &&
					<div className="spinner-grow text-primary" role="status">
						<span className="visually-hidden">Loading ...</span>
					</div>
				}
				{style === 'rotate' &&
					<div className="spinner-border text-primary" role="status">
						<span className="visually-hidden">Uploading ...</span>
					</div>
				}
			</Fragment>
		);
	}
}

export default Spinner;
